<template>
    <div class="dropdown uk-inline">
        <button class="uk-button" type="button">
            <span class="uk-text-meta">{{ title }} </span>
            <span>{{ period }}</span>
            <img :src="require('@/assets/images/icons/icon-arrow-next.svg')" alt="arrow-icon" class="rotate-90" />
        </button>
        <div ref="dropdown" class="time-period-dropdown" uk-dropdown="mode: click">
            <ul class="uk-nav uk-dropdown-nav uk-padding-small uk-open">
                <li v-for="(item, index) in data" :key="index" class="time-periods" @click="emitData(item, index)">
                    <a :class="{ active: period === item }">{{ item }}</a>
                </li>
            </ul>
            <div v-if="isVisible" class="date-picker">
                <div class="date-picker-header">
                    <h2>Custom calendar</h2>
                    <button class="date-picker-button" @click="isVisible = false">x</button>
                </div>
                <label>From</label>
                <input :value="from" class="time-period-input" readonly type="text" />
                <label>To</label>
                <input :value="to" class="time-period-input" readonly type="text" />
                <DatePicker v-model="date" :model-config="modelConfig" color="saysimple" is-range mode="date" />
            </div>
        </div>
    </div>
</template>

<script lang="js">
import Vue from "vue";
import { DateTime } from "luxon";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default Vue.extend({
    name: "CheckboxDropdown",
    components: {
        DatePicker,
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        selected: {
            required: false,
            type: String,
        },
        data: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            isVisible: false,
            period: "",
            date: {
                start: DateTime.utc(),
                end: DateTime.utc(),
            },
            from: "",
            to: "",
            modelConfig: {
                type: "string",
            },
            aggregationTypes: [
                {
                    minutes: 1220,
                    value: "today",
                },
                {
                    minutes: 2880,
                    value: "thisWeek",
                },
                {
                    minutes: 9970,
                    value: "thisMonth",
                },
                {
                    minutes: 44640,
                    value: "thisYear",
                },
                {
                    minutes: 1051200,
                    value: "thisYear",
                },
                {
                    minutes: 2628000,
                    value: "lastYear",
                },
            ],
        };
    },
    watch: {
        date: function() {
            this.emitData("Custom period", "custom");

            this.from = DateTime.fromISO(this.date.start.toString()).toLocaleString(DateTime.DATE_FULL);
            this.to = DateTime.fromISO(this.date.end.toString()).toLocaleString(DateTime.DATE_FULL);
        },
    },
    mounted() {
        this.period = this.data.last28Days;
    },
    methods: {
        emitData(selectedValue, selectedDate) {
            this.isVisible = selectedValue === "Custom period";

            const date = DateTime.utc();
            const today = DateTime.utc(date.year, date.month, date.day, 0, 0, 0, 0);
            const selectableDates = {
                ["today"]: [today, today.plus({ days: 1 })],
                ["yesterday"]: [today.minus({ days: 1 }), today],
                ["dayBeforeYesterday"]: [today.minus({ days: 2 }), today.minus({ days: 1 })],
                ["thisWeek"]: [today.minus({ days: today.weekday - 1 }), today.plus({ days: 8 - today.weekday })],
                ["lastWeek"]: [today.minus({ days: today.weekday + 6 }), today.minus({ days: today.weekday - 1 })],
                ["thisMonth"]: [
                    today.minus({ days: today.day - 1 }),
                    today.plus({ months: 1 }).minus({ days: today.day - 1 }),
                ],
                ["last28Days"]: [today.minus({ days: 27 }), today.plus({ days: 1 })],
                ["lastMonth"]: [
                    today.minus({ days: today.day - 1 + today.minus({ days: today.day }).day }),
                    today.minus({ days: today.day - 1 }),
                ],
                ["thisYear"]: [DateTime.utc(today.year, 1, 1), DateTime.utc(today.year + 1, 1, 1)],
                ["lastYear"]: [DateTime.utc(today.year - 1, 1, 1), DateTime.utc(today.year, 1, 1)],
                ["custom"]: [
                    DateTime.fromISO(this.date.start.toString()).plus({ hour: 2 }),
                    DateTime.fromISO(this.date.end.toString()).plus({ day: 1 }),
                ],
            };
            if (this.period !== selectedValue || this.period === "Custom period") {
                this.period = selectedValue;
                this.storeDates(selectedDate, ...selectableDates[selectedDate]);
            }
        },
        storeDates(timePeriod, startDate, endDate) {
            if (timePeriod.toLowerCase() === "custom") {
                const difference = endDate.diff(startDate, "minutes").toObject();
                const minutes = difference.minutes || 0;
                timePeriod = "last28Days";

                this.aggregationTypes.forEach((aggregation) => {
                    if (minutes >= aggregation.minutes) {
                        timePeriod = aggregation.value;
                    }
                });
            }

            this.$store.commit("graphs/mutateDates", {
                startDate: startDate.toString(),
                endDate: endDate.toString(),
                timePeriod,
            });
        },
    },
});
</script>
